import { connect } from 'react-redux';

import { createLicense, uploadSeed, uploadContract } from '../actions/license';

import { LicenseCreateForm } from '../components/license-list';

const mapState = state => ({
  isAdmin: state.user.profile.isAdmin,
  maxLicenseDay: state.user.profile.maxLicenseDay,
  userToken: state.user.profile.token,
  signature: state.license.seedUpload.signature,
  seedUploadError: state.license.seedUpload.error,
  contractID: state.license.contract.contractID,
  contractError: state.license.contract.error
});

const mapDispatch = {
  createLicense,
  uploadSeed,
  uploadContract
};

export default connect(
  mapState,
  mapDispatch
)(LicenseCreateForm);
